import { Navigate } from 'react-router-dom'
import { useAuth } from './shared/contexts/AuthContext';

export const App = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Quem está ligado a mais do que um estate tem um portefólio — manda-o
  // para o selector em vez de entrar logo num só.
  if ((user?.estateIds?.length ?? 0) > 1) {
    return <Navigate to="/properties" replace />
  }

  return <Navigate to={user?.estateId ? `/properties/${user.estateId}` : '/properties'} replace />
}

